import register from '@kpsys/angularjs-register';
import OpeningCalendarDataService from './kp-opening-calendar.data-service';

/**
 * @ngdoc module
 * @name portaro.components.opening-calendar
 * @module portaro.components.opening-calendar
 */

/**
 * @ngdoc object
 * @name openingCalendarApiUrl
 * @module portaro.components.opening-calendar
 *
 * @description
 * This value contains default URL for {@link service:openingCalendarDataService}.
 * By default is `'opening-calendar'`.
 */

export default register('portaro.components.opening-calendar')
    .service(OpeningCalendarDataService.serviceName, OpeningCalendarDataService)
    .value('openingCalendarApiUrl', 'opening-calendar')
    .name();